import { StorefrontIcon, ShoppingBasketIcon } from '@occc/ui-design-system';

export enum ChallengeType {
  ProductChallenge = 'productChallenge',
  VisitChallenge = 'visitChallenge',
}

export const challengeTypes = [
  {
    type: ChallengeType.ProductChallenge,
    title: 'Variety Challenge',
    description:
      'Award Members for purchasing a variety of products by quantity or value over time.',
    icon: ShoppingBasketIcon,
  },
  {
    type: ChallengeType.VisitChallenge,
    title: 'Visit Challenge',
    description: 'Award Members when they make a specific number of transactions',
    icon: StorefrontIcon,
  },
];
